/* GENERATED FILE — do not edit.
   Source: shared-ui/ui/videoSource.js
   Run "node shared-ui/sync.js" after editing the source. */
/*
 * One place that knows how to turn a stored file id into playable URLs.
 *
 * The API hands out two shapes of the same id:
 *   userchallenges.FileID  -> "OTH_1765263283170"       (no extension)
 *   userposts.VideoID      -> "OTH_1776519939061.mov"   (with extension)
 * Wowza never answers on the extension form, so it is always stripped first.
 *
 * The Wowza library then holds TWO naming conventions, and neither covers
 * everything. Measured against five real ids:
 *
 *   id                  {id}.smil   1080_{id}.mp4   720_{id}.mp4
 *   OTH_1776519939061      200          200             404
 *   OTH_1746350423376      404          200             200
 *   OTH_1765263283170      200          200             404
 *   OTH_1727806337867      200          200             404
 *   OTH_1762181615011      200          200             404
 *
 * 1080_{id}.mp4 is the only form that answered for every file, so it leads.
 * The others follow as fallbacks — the player walks the list on error, which
 * is why a clip whose .smil was never generated still plays.
 */

/* "OTH_123.mov" -> "OTH_123"; leaves an already-clean id untouched. */
export function baseFileId(fileId) {
  const raw = String(fileId || '').trim();
  if (!raw) return '';
  return raw.replace(/\.(mp4|mov|m4v|avi|mkv|webm|smil)$/i, '');
}

/* Every HLS URL worth trying for this id, best first. Always https. */
export function videoCandidates(fileId) {
  const id = baseFileId(fileId);
  if (!id) return [];
  const base = process.env.REACT_APP_VIDEO_BASE_URL;
  return [
    `${base}1080_${id}.mp4/playlist.m3u8`,
    `${base}${id}.smil/playlist.m3u8`,
    `${base}720_${id}.mp4/playlist.m3u8`,
  ];
}

/* The first candidate — for callers that only need one URL. */
export function videoUrl(fileId) {
  const list = videoCandidates(fileId);
  return list.length > 0 ? list[0] : '';
}

/* Poster frame. Lives on the video host, NOT on the retired vodmaster domain. */
export function posterUrl(fileId) {
  const id = baseFileId(fileId);
  if (!id) return '';
  return `${process.env.REACT_APP_VIDEOSERVER_API}${id}.jpg`;
}

export default videoUrl;
